import React, { useContext, useEffect, useState } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import {
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import SideBar from '../../uiParts/SideBar';
import { sideBarWidth } from '../../../constants/Location';
import {
  gray10,
  gray100,
  gray70,
  gray90,
  green10,
  green100,
  primary10,
  primaryButtonBackgroundColor,
  primaryButtonOutlinedColor,
  primaryColor,
  red10,
  red100
} from '../../../constants/Colors';
import {
  AccountCircleOutlined,
  BarChart,
  // ChatBubbleOutline,
  KeyboardArrowRight,
  LightbulbOutlined
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import noImage from '../../assets/noImage.svg';
import { NewsType, getNewsList } from '../../../api/microcms/news';
import { getMemberNewsList } from '../../../api/db/news';
import { MemberNewsListGetType } from '../../../validation/news/newsType';
import { MylistGetProductType } from '../../../validation/mylist/mylistType';
import { getMylistInfo } from '../../../api/db/mylist';
import { FavoriteGetProductType } from '../../../validation/favorite/favoriteType';
import {
  ImageDataType,
  MyProductGetProductType
} from '../../../validation/products/productType';
import { getFavorites } from '../../../api/db/favorite';
import {
  applyMaker,
  getCustomerInfo,
  readNaviPanel
} from '../../../api/db/user';
import { getMyProductList } from '../../../api/db/product';
import CustomLoading from '../../uiParts/CustomLoading';
import CustomSnackbar from '../../uiParts/CustomSnackbar';
import { AxiosError } from 'axios';
import { response } from '../../../api/db';
import { common } from '../../../modules/error';
import {
  co2StatuEnum,
  orderOnGetFavoriteProducts,
  userType as UserTypeEnum
} from '../../../constants/Enum';
import { AuthContext } from '../../../contexts/auth';
import CustomHead from '../CustomHead';
import dayjs from 'dayjs';
import { readCo2Setting } from '../../../api/db/co2Setting';
import { sentryLog } from '../../../config/sentry';
import EnvironmentInfoModal from '../../uiParts/EnvironmentInfoModal';
import Navipanel from '../../uiParts/NaviPanel';

const styles = {
  wrapper: {
    p: '32px',
    '@media screen and (max-width:960px)': {
      p: '24px 16px'
    }
  },
  title: {
    fontSize: '32px',
    fontWeight: 500,
    color: gray100,
    '@media screen and (max-width:600px)': {
      fontSize: '24px'
    }
  },
  info: {
    bgcolor: primary10,
    border: '1px solid' + primaryColor,
    borderRadius: '4px',
    p: '13px 16px',
    mt: '24px',
    width: '100%'
  },
  infoIcon: {
    color: primaryColor,
    mr: '12px',
    width: '22px',
    height: '22px'
  },
  infoText: {
    fontSize: '14px',
    color: gray100
  },
  infoTextAndLink: {
    justifyContent: 'space-between',
    width: 'calc(100% - 34px)',
    '@media screen and (max-width:620px)': {
      flexDirection: 'column'
    }
  },
  infoLinkContainer: {
    '@media screen and (max-width:620px)': {
      mt: '12px'
    }
  },
  sectionContainer: {
    mt: '24px',
    p: '24px',
    border: '1px solid' + gray70,
    borderRadius: '4px',
    '@media screen and (max-width:960px)': {
      p: '24px 16px'
    }
  },
  sectionTitle: {
    fontSize: '24px',
    fontWeight: 500,
    color: gray100,
    '@media screen and (max-width:600px)': {
      fontSize: '18px'
    }
  },
  linkAll: {
    color: primaryColor,
    fontSize: '16px'
  },
  chip: {
    fontSize: '12px',
    height: '22px',
    m: '0px 8px'
  },
  date: {
    color: gray90,
    fontSize: '16px',
    m: '0px 8px',
    '@media screen and (max-width:600px)': {
      fontSize: '14px'
    }
  },
  newsTitle: {
    color: gray100,
    fontSize: '16px',
    ml: '8px',
    '@media screen and (max-width:600px)': {
      display: 'flex',
      width: '100%',
      fontSize: '14px',
      mt: '8px'
    }
  },
  text: {
    fontSize: '16px',
    color: gray100,
    '@media screen and (max-width:600px)': {
      fontSize: '14px'
    }
  },
  button: {
    fontSize: '16px',
    width: '320px',
    height: '44px',
    mt: '24px',
    '@media screen and (max-width:600px)': {
      width: '100%'
    },
    ...primaryButtonOutlinedColor
  },
  empty: {
    fontSize: '16px',
    color: gray90,
    bgcolor: gray10,
    p: '16px 24px',
    mt: '24px',
    '@media screen and (max-width:600px)': {
      textAlign: 'center',
      p: '16px 50px'
    }
  },
  itemContainer: {
    mt: '24px',
    width: '100%'
  },
  userSettingItem: {
    bgcolor: gray10,
    p: '26px 24px',
    cursor: 'pointer',
    '@media screen and (max-width:1200px)': {
      mb: '16px'
    }
  },
  searchButton: {
    fontSize: '16px',
    width: '320px',
    height: '44px',
    mt: '24px',
    '@media screen and (max-width:600px)': {
      width: '100%'
    },
    ...primaryButtonBackgroundColor
  },
  settingIcon: {
    width: '32px',
    height: '32px',
    color: primaryColor,
    '@media screen and (max-width:600px)': {
      width: '24px',
      height: '24px'
    }
  },
  settingTitle: {
    color: gray100,
    fontSize: '24px',
    fontWeight: 500,
    '@media screen and (max-width:600px)': {
      fontSize: '18px'
    },
    '@media screen and (max-width: 1260px)': {
      fontSize: '20px'
    }
  },
  tableTitle: {
    fontSize: '14px',
    color: gray90,
    mb: '8px',
    '@media screen and (max-width:600px)': {
      fontSize: '12px'
    }
  },
  headCell: {
    color: gray100,
    fontSize: '12px',
    border: '1px solid' + gray70,
    bgcolor: primary10,
    height: '32px',
    p: '0 12px'
  },
  cell: {
    color: gray100,
    fontSize: '12px',
    border: '1px solid' + gray70,
    height: '44px',
    p: '0 12px'
  },
  materialItem: {
    height: '100%',
    flexGrow: 1,
    maxWidth: '198px',
    '@media screen and (max-width:600px)': {
      maxWidth: '148px'
    },
    cursor: 'pointer'
  },
  materialItemImage: {
    width: '100%',
    height: '100%'
  },
  materialItemText: {
    fontSize: '12px',
    '@media screen and (max-width:600px)': {
      fontSize: '10px'
    }
  },
  materialItemTitle: {
    color: gray100,
    fontSize: '14px',
    fontWeight: 700,
    '@media screen and (max-width:600px)': {
      fontSize: '12px'
    }
  },
  itemNum: {
    color: gray90,
    fontSize: '14px',
    fontWeight: 500,
    mt: '8px',
    width: '100%',
    textAlign: 'end'
  }
};

const Home = (): React.ReactElement => {
  const navigate = useNavigate();
  const { checkLoginStatus } = useContext(AuthContext);
  const [openInfo, setOpenInfo] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const windowWidthBorder = 960;
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [subtractionWidth, setSubtractionWidth] = useState(613);
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [errorText, setErrorText] = useState<string>('');

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    if (window.innerWidth >= windowWidthBorder) {
      setSubtractionWidth(352);
    } else if (window.innerWidth < windowWidthBorder) {
      setSubtractionWidth(70);
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowWidth]);

  interface HomeNewsType {
    id: string;
    title: string;
    isGeneral: boolean;
    date: string;
    tag?: string[];
  }
  const [displayNewsItems, setDisplayNewsItems] = useState<HomeNewsType[]>([]);
  const fetchNewsData = async (): Promise<void> => {
    const generalNewsRes = await getNewsList(1);

    const displayGeneralNews: HomeNewsType[] = generalNewsRes.contents.map(
      (generalNews: NewsType) => {
        const tag = [];
        generalNews.important_flg && tag.push('重要');
        generalNews.category && tag.push(generalNews.category);
        return {
          id: generalNews.id,
          title: generalNews.title,
          date: generalNews.updatedAt,
          isGeneral: true,
          tag: tag
        };
      }
    );

    const memberNewsRes = await getMemberNewsList(5, 0);
    const displayMemberNews: HomeNewsType[] =
      memberNewsRes.data.member_news.map(
        (memberNews: MemberNewsListGetType) => {
          const tag = memberNews.read_flg ? ['既読'] : ['未読'];
          return {
            id: memberNews.id,
            title: memberNews.title,
            date: memberNews.updated_at,
            tag: tag,
            isGeneral: false
          };
        }
      );
    const newsItems = [...displayGeneralNews, ...displayMemberNews];
    const sortedNewsItems = newsItems.sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateB.getTime() - dateA.getTime();
    });
    setDisplayNewsItems(sortedNewsItems.slice(0, 5));
  };

  const [mylist, setMylist] = useState<MylistGetProductType[]>([]);
  const [mylistCount, setMylistCount] = useState<number>(0);

  const fetchMylistData = async (): Promise<void> => {
    const offset = 0;
    const order = 2;
    const method = 1;
    if (!usingMylistId) return;
    const res = await getMylistInfo(usingMylistId, offset, order, method);
    setMylistCount(res.response_count);
    setMylist(res.products.slice(0, 3));
  };

  const [currentUserType, setCurrentUserType] = useState<number>(0);
  const [userCO2Status, setUserCO2Status] = useState<number>(0);
  const [co2DefaultId, setCo2DefaultId] = useState<number | null>(null);
  const [usingMylistId, setUsingMylistId] = useState<number | null>(null);
  const fetchUserInfo = async (): Promise<void> => {
    const response = await getCustomerInfo();
    setUserCO2Status(response.data.co2_status);
    setCo2DefaultId(response.data.co2_default_id);
    setCurrentUserType(response.data.type);
    setUsingMylistId(response.data.use_mylist_id);
  };

  interface HomeMaterialInfoType {
    id: number;
    productInfoId?: number;
    name: string;
    alias: string;
    category: string;
    material: string;
    mainImagePath: string;
  }
  const [favoriteItems, setFavoriteItems] = useState<HomeMaterialInfoType[]>(
    []
  );
  const [favoriteItemsCount, setFavoriteItemsCount] = useState<number>(0);
  const fetchFavoriteData = async (): Promise<void> => {
    const limit = 5;
    const offset = 0;
    const order = orderOnGetFavoriteProducts.descCreatedAt;
    const method = 1;
    const res = await getFavorites(limit, offset, order, method);
    setFavoriteItemsCount(res.total_count);
    const favoriteItems: HomeMaterialInfoType[] = res.products.map(
      (product: FavoriteGetProductType) => {
        const mainImage = product.image.find(
          (image: ImageDataType) => image.sort === 1
        );
        return {
          id: product.id,
          name: product.name,
          alias: product.alias,
          category: product.category.name,
          material: product.material.name,
          mainImagePath: mainImage ? mainImage.filepath : ''
        };
      }
    );
    setFavoriteItems(favoriteItems);
  };

  const [registerMaterialItems, setRegisterMaterialItems] = useState<
    HomeMaterialInfoType[]
  >([]);
  const [registerMaterialItemsCount, setRegisterMaterialItemsCount] =
    useState<number>(0);
  const fetchRegisterMaterialData = async (): Promise<void> => {
    const limit = 5;
    const offset = 0;
    const order = 2;
    const method = 1;
    const res = await getMyProductList(limit, offset, order, method);
    setRegisterMaterialItemsCount(res.total_count);
    const registerMaterialItems: HomeMaterialInfoType[] = res.products.map(
      (product: MyProductGetProductType) => {
        const mainImage = product.image.find(
          (image: ImageDataType) => image.sort === 1
        );
        return {
          id: product.id,
          productInfoId: product.product_info_id,
          name: product.name,
          alias: product.alias,
          category: product.category.name,
          material: product.material.name,
          mainImagePath: mainImage ? mainImage.filepath : ''
        };
      }
    );
    setRegisterMaterialItems(registerMaterialItems);
  };

  const onAxiosError = (error: AxiosError): void => {
    if (error.response) {
      const responseError = error.response as response;
      setErrorText(responseError.data.message);
    } else {
      setErrorText(common);
    }
    setSnackbarOpen(true);
  };

  const [naviOpen, setNaviOpen] = useState<boolean>(false);
  const [userRole, setUserRole] = useState<number | null>(null);

  const handleNaviOpen = async (naviStatus: number | null) => {
    if (naviStatus === 0) {
      setNaviOpen(true);
      await readNaviPanel();
    }
  };

  useEffect(() => {
    void (async () => {
      if (checkLoginStatus) {
        const result = await checkLoginStatus();
        // 未ログイン時はログイン画面に飛ばす
        if (!result.check) return navigate('/auth/login');

        try {
          fetchUserInfo();
          handleNaviOpen(result.navi);
          setUserRole(result.role);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          sentryLog(error);
          onAxiosError(error as AxiosError);
        }
      }
    })();
    setIsLoading(true);
  }, []);

  const [showData, setShowData] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (checkLoginStatus) {
          // 未ログイン時はログイン画面に飛ばす
          const result = await checkLoginStatus();
          if (!result.check) return navigate('/auth/login');

          if (currentUserType === UserTypeEnum.maker) {
            await fetchRegisterMaterialData();
          }
          await fetchNewsData();
          await fetchMylistData();
          await fetchFavoriteData();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        sentryLog(error);
        onAxiosError(error as AxiosError);
      } finally {
        setIsLoading(false);
        setShowData(true);
      }
    };
    fetchData();
  }, [currentUserType, usingMylistId]);

  useEffect(() => {
    setOpenInfo(
      userCO2Status === co2StatuEnum.notset ||
        userCO2Status === co2StatuEnum.add ||
        userCO2Status === co2StatuEnum.edit
    );
  }, [userCO2Status]);

  const readCO2Status = async () => {
    setIsLoading(true);
    try {
      await readCo2Setting();
      setOpenInfo(false);
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      sentryLog(error);
      const axiosError = error as AxiosError;
      if (axiosError.isAxiosError && axiosError.response) {
        const loginErrorResponse = axiosError.response as response;
        setErrorText(loginErrorResponse.data.message);
        setSnackbarOpen(true);
      } else {
        setErrorText(common);
        setSnackbarOpen(true);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const NewsRow = (news: HomeNewsType): React.ReactElement => {
    const getTagColor = (tag: string): { color: string; bgcolor: string } => {
      switch (tag) {
        case '重要':
          return { color: red100, bgcolor: red10 };
        case '新機能':
          return { color: primaryColor, bgcolor: primary10 };
        case '既読':
          return { color: gray90, bgcolor: gray10 };
        case '未読':
          return { color: green100, bgcolor: green10 };
        default:
          return { color: primaryColor, bgcolor: primary10 };
      }
    };
    return (
      <>
        <Divider sx={{ width: '100%', m: '12px 0' }} />
        <Grid item xs={12} sx={{ cursor: 'pointer' }}>
          <Grid
            container
            alignItems="center"
            sx={{
              '@media screen and (min-width:601px)': {
                flexWrap: 'nowrap'
              }
            }}
            onClick={() =>
              navigate(
                `/news/${news.isGeneral ? 'general' : 'member'}/${news.id}`
              )
            }
          >
            <Typography sx={styles.date}>
              {dayjs(news.date).format('YYYY/MM/DD')}
            </Typography>
            {news.tag &&
              news.tag.map((tag: string, index: number) => (
                <Chip
                  key={index}
                  label={tag}
                  sx={{
                    ...styles.chip,
                    ...getTagColor(tag),
                    ml: index === 0 ? '8px' : '0px'
                  }}
                />
              ))}
            <Typography sx={styles.newsTitle}>{news.title}</Typography>
          </Grid>
        </Grid>
      </>
    );
  };

  const MylistRow = (mylist: MylistGetProductType): React.ReactElement => {
    return (
      <TableRow
        sx={{
          '&:hover': {
            bgcolor: gray10,
            cursor: 'pointer'
          }
        }}
        onClick={() => {
          navigate('/material/' + mylist.id);
        }}
      >
        <TableCell sx={{ ...styles.cell }}>
          {mylist.alias?.length > 12
            ? mylist.alias.slice(0, 12) + '...'
            : mylist.alias}
        </TableCell>
        <TableCell sx={{ ...styles.cell }}>
          {mylist.name?.length > 18
            ? mylist.name.slice(0, 18) + '...'
            : mylist.name}
        </TableCell>
        <TableCell sx={{ ...styles.cell }}>
          {' '}
          {mylist.specification?.length > 22
            ? mylist.specification.slice(0, 22) + '...'
            : mylist.specification}
        </TableCell>
        <TableCell sx={{ ...styles.cell }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography
              sx={{ fontSize: '12px', color: primaryColor, fontWeight: 700 }}
            >
              {mylist.emission_intensity !== null
                ? mylist.emission_intensity?.toLocaleString()
                : 'ー '}
            </Typography>
            <Typography sx={{ fontSize: '10px', color: gray100, ml: '3px' }}>
              kg-CO2/{mylist.material.co2_unit}
            </Typography>
          </Box>
        </TableCell>
        <TableCell sx={{ ...styles.cell }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography
              sx={{ fontSize: '12px', color: primaryColor, fontWeight: 700 }}
            >
              {'△'} {mylist.reduce_rate !== null ? mylist.reduce_rate : 'ー '}
            </Typography>
            <Typography sx={{ fontSize: '10px', color: gray100, ml: '3px' }}>
              %
            </Typography>
          </Box>
        </TableCell>
        <TableCell sx={{ ...styles.cell, textAlign: 'right' }}>
          {mylist.reference_unit_price?.toLocaleString()}
        </TableCell>
        <TableCell sx={{ ...styles.cell }}>
          {mylist.users.company_short}
        </TableCell>
      </TableRow>
    );
  };

  const MaterialItem = (item: HomeMaterialInfoType): React.ReactElement => {
    const navigate = useNavigate();
    return (
      <Box
        sx={styles.materialItem}
        onClick={() =>
          navigate(`/material/${item.id}`, {
            state: { productInfoId: item.productInfoId }
          })
        }
      >
        <Box
          component="img"
          src={item.mainImagePath || noImage}
          sx={styles.materialItemImage}
        />
        <Typography
          sx={{
            ...styles.materialItemText,
            color: gray100,
            mt: '8px'
          }}
        >
          {item.alias?.length > 12
            ? item.alias.slice(0, 12) + '...'
            : item.alias}
        </Typography>
        <Typography
          sx={{
            ...styles.materialItemText,
            color: gray90,
            mb: '4px'
          }}
        >
          {item.category ? item.category : ''}
          {item.category && item.material ? ' / ' : ''}
          {item.category && item.material
            ? item.material.length > 12
              ? item.material.slice(0, 12) + '...'
              : item.material
            : ''}
        </Typography>
        <Typography sx={styles.materialItemTitle}>
          {item.name?.length > 27 ? item.name.slice(0, 27) + '...' : item.name}
        </Typography>
      </Box>
    );
  };

  const renderRegisterStatusMessage = (registerStatus: number): string => {
    switch (registerStatus) {
      case UserTypeEnum.view:
      case UserTypeEnum.rejectedMaker:
        return '自社の建材を登録する場合は、登録会員への変更手続きが必要です。以下から申し込みしてください。';
      case UserTypeEnum.applyingMaker:
        return '建材登録会員の申請を受け付けました。確認および認証まで3営業日ほどかかります。完了次第メールでお知らせします。';
      case UserTypeEnum.maker:
        return '自社の建材を登録・編集・削除する場合は、こちらからお願いします。';
      default:
        return '';
    }
  };

  const handleClickRegister = async () => {
    try {
      setIsLoading(true);
      await applyMaker();
      navigate('/exhibit_apply/complete');
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      sentryLog(error);
      onAxiosError(error as AxiosError);
    } finally {
      await fetchUserInfo();
      setIsLoading(false);
    }
  };

  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleEdit = () => {
    setModalOpen(false);
    navigate('/account/basic');
  };

  const handleClick = async () => {
    // 会員情報からcertification_flgを確認
    const res = await getCustomerInfo();
    const certificationFlg = res.data.certification_flg;
    if (certificationFlg === null) {
      // nullの場合は入力を促すモーダルを表示
      handleOpenModal();
    } else {
      handleClickRegister();
    }
  };

  return (
    <>
      <CustomHead title="ホーム | CMCOS[コムコス]" />
      <Grid>
        <CustomSnackbar
          onClose={() => setSnackbarOpen(false)}
          open={snackbarOpen}
          text={errorText ?? ''}
        />
        <SideBar />
        <CustomLoading loading={isLoading} />
        {showData && (
          <Grid
            sx={{
              '@media screen and (min-width:961px)': {
                ml: sideBarWidth
              }
            }}
          >
            <Grid container flexDirection="column" sx={styles.wrapper}>
              <Grid item>
                <Typography sx={styles.title}>ホーム</Typography>
              </Grid>
              {openInfo && (
                <Grid item>
                  <Grid container alignContent="center" sx={styles.info}>
                    <LightbulbOutlined sx={styles.infoIcon} />
                    <Grid container sx={styles.infoTextAndLink}>
                      <Typography sx={styles.infoText}>
                        {(() => {
                          if (userCO2Status === co2StatuEnum.notset) {
                            return '最初にCO2基準値を確認・修正してください';
                          } else if (userCO2Status === co2StatuEnum.add) {
                            return '部材名が追加されました。CO2基準値を確認・修正してください';
                          } else if (userCO2Status === co2StatuEnum.edit) {
                            return '部材名が更新されました。CO2基準値を確認・修正してください';
                          }
                        })()}
                      </Typography>
                      <Box sx={styles.infoLinkContainer}>
                        <Typography
                          component={'a'}
                          href={
                            userCO2Status === co2StatuEnum.edit
                              ? `/standard/${co2DefaultId}`
                              : '/standard'
                          }
                          sx={styles.infoText}
                        >
                          CO2基準値を設定する
                        </Typography>
                        <Typography
                          component={'a'}
                          onClick={() => readCO2Status()}
                          sx={{
                            ...styles.infoText,
                            ml: '24px',
                            textDecoration: 'underline',
                            cursor: 'pointer'
                          }}
                        >
                          閉じる
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              )}
              <Grid item>
                <Grid container sx={styles.sectionContainer}>
                  <Grid item xs={12}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item>
                        <Typography sx={styles.sectionTitle}>
                          お知らせ
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          component={'a'}
                          sx={styles.linkAll}
                          href="/news"
                        >
                          すべて見る
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  {displayNewsItems.map((news: HomeNewsType, index: number) => (
                    <NewsRow key={index} {...news} />
                  ))}
                </Grid>
              </Grid>
              <Grid item>
                <Grid container sx={styles.sectionContainer}>
                  <Grid item xs={12}>
                    <Typography sx={styles.sectionTitle} mb="12px">
                      建材検索
                    </Typography>
                    <Typography sx={styles.text}>
                      各条件で低CO2建材を検索できます。まずはここから建材を探して、プロジェクトに適する建材を「マイリスト」に追加してください。​
                    </Typography>
                    <Button
                      sx={styles.searchButton}
                      variant="outlined"
                      onClick={() => navigate('/material')}
                    >
                      <SearchIcon sx={{ mr: '8px' }} />
                      建材を探す
                    </Button>
                  </Grid>
                  <Divider sx={{ width: '100%', m: '32px 0' }} />
                  <Grid item xs={12}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      mb="12px"
                    >
                      <Grid item>
                        <Typography sx={styles.sectionTitle}>
                          マイリスト
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          component={'a'}
                          href="/mylist"
                          sx={styles.linkAll}
                        >
                          すべて見る
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography sx={styles.text}>
                      「マイリスト」に追加した建材は一括してデータを出力することができます。建材検索等から建材を選択してください。​
                    </Typography>
                    {mylistCount === 0 ? (
                      <Typography sx={styles.empty}>
                        マイリストに登録した建材はまだありません
                      </Typography>
                    ) : (
                      <Box sx={styles.itemContainer}>
                        <Typography sx={styles.tableTitle}>
                          現在マイリストに追加されている建材​
                        </Typography>
                        <TableContainer
                          sx={{ width: windowWidth - subtractionWidth }}
                          component={Box}
                        >
                          <Table sx={{ minWidth: '1086px' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '172px' }}
                                >
                                  一般名称
                                </TableCell>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '235px' }}
                                >
                                  商品名
                                </TableCell>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '276px' }}
                                >
                                  仕様
                                </TableCell>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '108px' }}
                                >
                                  CO2原単位
                                </TableCell>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '83px' }}
                                >
                                  CO2削減率
                                </TableCell>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '96px' }}
                                >
                                  参考設計単価
                                </TableCell>
                                <TableCell
                                  sx={{ ...styles.headCell, width: '116px' }}
                                >
                                  会社名
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {mylist.map(
                                (
                                  mylist: MylistGetProductType,
                                  index: number
                                ) => (
                                  <MylistRow key={index} {...mylist} />
                                )
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {mylistCount > 3 && (
                          <Typography sx={styles.itemNum}>{`+${
                            mylistCount - 3
                          }件`}</Typography>
                        )}
                      </Box>
                    )}
                  </Grid>
                  <Divider sx={{ width: '100%', m: '32px 0' }} />
                  <Grid item xs={12}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      mb="12px"
                    >
                      <Grid item>
                        <Typography sx={styles.sectionTitle}>
                          お気に入り
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          component={'a'}
                          href="/favorite"
                          sx={styles.linkAll}
                        >
                          すべて見る
                        </Typography>
                      </Grid>
                    </Grid>
                    <Typography sx={styles.text}>
                      「お気に入り」に登録すると建材検索が簡単になります。気になる建材を見つけた時は、こちらに登録しておくと便利です。​
                    </Typography>
                    {favoriteItemsCount === 0 ? (
                      <Typography sx={styles.empty}>
                        お気に入りの建材はまだありません
                      </Typography>
                    ) : (
                      <Box
                        sx={styles.itemContainer}
                        gap={'24px'}
                        flexWrap={'wrap'}
                        display={'flex'}
                      >
                        {favoriteItems.map(
                          (item: HomeMaterialInfoType, index: number) => (
                            <MaterialItem key={index} {...item} />
                          )
                        )}
                        {favoriteItemsCount > 5 && (
                          <Typography sx={styles.itemNum}>{`+${
                            favoriteItemsCount - 5
                          }件`}</Typography>
                        )}
                      </Box>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container sx={styles.sectionContainer}>
                  <Grid item xs={12}>
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="center"
                      mb="12px"
                    >
                      <Grid item>
                        <Typography sx={styles.sectionTitle}>
                          建材登録
                        </Typography>
                      </Grid>
                      {currentUserType === UserTypeEnum.maker && (
                        <Grid item>
                          <Typography
                            component={'a'}
                            href="/product"
                            sx={styles.linkAll}
                          >
                            すべて見る
                          </Typography>
                        </Grid>
                      )}
                    </Grid>
                    <Typography sx={styles.text}>
                      {renderRegisterStatusMessage(currentUserType)}
                    </Typography>
                    {currentUserType !== UserTypeEnum.maker && (
                      <>
                        <Button
                          sx={styles.button}
                          variant="outlined"
                          disabled={
                            currentUserType === UserTypeEnum.admin ||
                            currentUserType === UserTypeEnum.applyingMaker
                          }
                          onClick={handleClick}
                        >
                          {currentUserType === UserTypeEnum.applyingMaker
                            ? '建材登録会員の申し込み済み'
                            : '建材登録会員の申し込み'}
                        </Button>
                        <EnvironmentInfoModal
                          open={modalOpen}
                          onClose={handleCloseModal}
                          onEdit={handleEdit}
                        />
                      </>
                    )}
                    {currentUserType === UserTypeEnum.maker &&
                      (registerMaterialItemsCount === 0 ? (
                        <Typography sx={styles.empty}>
                          登録した建材はまだありません
                        </Typography>
                      ) : (
                        <Box
                          sx={styles.itemContainer}
                          gap={'24px'}
                          flexWrap={'wrap'}
                          display={'flex'}
                        >
                          {registerMaterialItems.map(
                            (item: HomeMaterialInfoType) => (
                              <MaterialItem key={item.id} {...item} />
                            )
                          )}
                          {registerMaterialItemsCount > 5 && (
                            <Typography sx={styles.itemNum}>{`+${
                              registerMaterialItemsCount - 5
                            }件`}</Typography>
                          )}
                        </Box>
                      ))}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container sx={styles.sectionContainer}>
                  <Grid item xs={12}>
                    <Typography sx={styles.sectionTitle} mb="12px">
                      ユーザー設定
                    </Typography>
                    <Grid container justifyContent="space-between">
                      <Grid
                        item
                        sx={styles.userSettingItem}
                        xs={12}
                        lg={5.9}
                        onClick={() => navigate('/standard')}
                      >
                        <Grid container>
                          <BarChart sx={styles.settingIcon} />
                          <Typography sx={styles.settingTitle} ml="16px">
                            CO2基準値
                          </Typography>
                          <KeyboardArrowRight
                            sx={{ ...styles.settingIcon, ml: 'auto' }}
                          />
                        </Grid>
                        <Typography sx={styles.text} mt="12px">
                          各部材について排出原単位の基準値を設定します。この数値をもとにCO2削減量、削減率を表示しています。
                        </Typography>
                      </Grid>
                      {/* <Grid
                        item
                        sx={styles.userSettingItem}
                        xs={12}
                        lg={3.9}
                        onClick={() => navigate('/evaluation')}
                      >
                        <Grid container>
                          <ChatBubbleOutline sx={styles.settingIcon} />
                          <Typography sx={styles.settingTitle} ml="16px">
                            評価した建材
                          </Typography>
                          <KeyboardArrowRight
                            sx={{ ...styles.settingIcon, ml: 'auto' }}
                          />
                        </Grid>
                        <Typography sx={styles.text} mt="12px">
                          ☆評価や口コミをした建材の確認・削除ができます。
                        </Typography>
                      </Grid> */}
                      <Grid
                        item
                        sx={styles.userSettingItem}
                        xs={12}
                        lg={5.9}
                        onClick={() => {
                          navigate('/account');
                          window.scrollTo(0, 0);
                        }}
                      >
                        <Grid container>
                          <AccountCircleOutlined sx={styles.settingIcon} />
                          <Typography sx={styles.settingTitle} ml="16px">
                            アカウント管理
                          </Typography>
                          <KeyboardArrowRight
                            sx={{ ...styles.settingIcon, ml: 'auto' }}
                          />
                        </Grid>
                        <Typography sx={styles.text} mt="12px">
                          会員登録情報の確認、編集ができます。
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
      <Navipanel
        show={naviOpen}
        userRole={userRole}
        onClose={() => setNaviOpen(false)}
      />
    </>
  );
};

export default Home;
